"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteData = SiteData;
exports.withSiteData = withSiteData;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _useSiteData = _interopRequireDefault(require("../hooks/useSiteData"));
function SiteData(_ref) {
  var children = _ref.children;
  return children((0, _useSiteData["default"])());
}
function withSiteData(Comp) {
  return function componentWithSiteData(props) {
    var routeData = (0, _useSiteData["default"])();
    return /*#__PURE__*/_react["default"].createElement(Comp, (0, _extends2["default"])({}, props, routeData));
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9icm93c2VyL2NvbXBvbmVudHMvU2l0ZURhdGEuanMiXSwibmFtZXMiOlsiU2l0ZURhdGEiLCJjaGlsZHJlbiIsIndpdGhTaXRlRGF0YSIsIkNvbXAiLCJjb21wb25lbnRXaXRoU2l0ZURhdGEiLCJwcm9wcyIsInJvdXRlRGF0YSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBRU8sU0FBU0EsUUFBVCxPQUFnQztBQUFBLE1BQVpDLFFBQVksUUFBWkEsUUFBWTtBQUNyQyxTQUFPQSxRQUFRLENBQUMsOEJBQUQsQ0FBZjtBQUNEOztBQUVNLFNBQVNDLFlBQVQsQ0FBc0JDLElBQXRCLEVBQTRCO0FBQ2pDLFNBQU8sU0FBU0MscUJBQVQsQ0FBK0JDLEtBQS9CLEVBQXNDO0FBQzNDLFFBQU1DLFNBQVMsR0FBRyw4QkFBbEI7QUFDQSx3QkFBTyxnQ0FBQyxJQUFELGdDQUFVRCxLQUFWLEVBQXFCQyxTQUFyQixFQUFQO0FBQ0QsR0FIRDtBQUlEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHVzZVNpdGVEYXRhIGZyb20gJy4uL2hvb2tzL3VzZVNpdGVEYXRhJ1xuXG5leHBvcnQgZnVuY3Rpb24gU2l0ZURhdGEoeyBjaGlsZHJlbiB9KSB7XG4gIHJldHVybiBjaGlsZHJlbih1c2VTaXRlRGF0YSgpKVxufVxuXG5leHBvcnQgZnVuY3Rpb24gd2l0aFNpdGVEYXRhKENvbXApIHtcbiAgcmV0dXJuIGZ1bmN0aW9uIGNvbXBvbmVudFdpdGhTaXRlRGF0YShwcm9wcykge1xuICAgIGNvbnN0IHJvdXRlRGF0YSA9IHVzZVNpdGVEYXRhKClcbiAgICByZXR1cm4gPENvbXAgey4uLnByb3BzfSB7Li4ucm91dGVEYXRhfSAvPlxuICB9XG59XG4iXX0=
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/browser/components/SiteData.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/browser/components/SiteData.js");
  }
}();